import React from "react";
import "./NavigationHeader.scss";
import Icon from "../Icons/Icons";
import { Link } from "react-router-dom";

const NavigationHeader = ({
  isAuthenticated = true,
  isClickable = true,
  ...props
}) => {
  return (
    <div className="navigation-header not-authenticated-header">
      {isClickable ? (
        <a href="/">
          <Icon.phyllo_icon_with_name
            name="phyllo_icon_with_name"
            className="phyllo-header-icon"
          />
        </a>
      ) : (
        <Icon.phyllo_icon_with_name
          name="phyllo_icon_with_name"
          className="phyllo-header-icon"
        />
      )}
    </div>
  );
};

export default NavigationHeader;
